import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';
import { Button, PopupFooter, PopupHeader, SearchInput } from '@gem/ui-kit';

import { CallSelectSpeakersList } from './CallSelectSpeakersList/CallSelectSpeakersList';
import { useCallSelectSpeakersPresenter } from './CallSelectSpeakersPopup.presenter';
import styles from './CallSelectSpeakersPopup.styles.m.css';
import { ICallSelectSpeakersPopupParams } from './CallSelectSpeakersPopup.types';

export const CallSelectSpeakersPopup: FC<ICommonPopupsProps<ICallSelectSpeakersPopupParams>> =
  observer((props) => {
    const { t } = useTranslation();
    const presenter = useCallSelectSpeakersPresenter(props);

    return (
      <Popup
        isOpened
        onClose={presenter.onClose}
      >
        <PopupHeader
          onClose={presenter.onClose}
          handlePrevStep={presenter.onBack}
          contentClassName={styles.header}
        >
          <div className={styles.title}>
            <p>{t('webinar_select_speakers_title')}</p>
            <div className={styles.subtitle}>
              {t('webinar_speakers_limit_counter', {
                0: presenter.selectedSpeakerIds.size,
                1: props.params?.maxSpeakers || 20,
              })}
            </div>
          </div>
        </PopupHeader>
        <SearchInput
          className={styles.search}
          placeholder={t('main_menu_search_note')}
          onChange={presenter.onChangeSearch}
          value={presenter.searchValue}
        />
        <CallSelectSpeakersList
          searchValue={presenter.searchValue}
          selectedSpeakerIds={presenter.selectedSpeakerIds}
          onSelectSpeaker={presenter.onSelectSpeaker}
        />
        <PopupFooter>
          <Button
            onClick={presenter.submit}
            isDisabled={!presenter.hasChanges}
          >
            {t('done')}
          </Button>
        </PopupFooter>
      </Popup>
    );
  });
